<template>
    <div class="item-divider">
        <el-button type="text" class="remove-btn f-edit" @click="removeItem(ruleForm)"><span
                class="color-danger">删除</span>
        </el-button>
        <el-form :model="ruleForm" :rules="rules" :class="[{ 'form-view': !isEdit }, 'form-switch', 'form-col']"
                 ref="ruleForm"
                 label-width="100px">
            <div class="col-2 clearfix">
                <el-form-item label="游戏名称:" prop="name">
                    <p class="f-view" v-text="ruleForm.name"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.name" :maxlength="20"
                              placeholder="请输入游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="游戏时长:" prop="duration">
                    <p class="f-view" v-text="ruleForm.duration"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.duration" :maxlength="20"
                              placeholder="请输入游戏时长"></el-input>
                </el-form-item>
            </div>
            <div class="clearfix">
                <el-form-item label="游戏成就:" prop="achievement">
                    <p class="f-view" v-text="ruleForm.achievement"></p>
                    <el-input class="f-edit" type="textarea" :autosize="{ minRows: 3, maxRows: 5}" v-model="ruleForm.achievement" placeholder="请输入游戏成就" resize="none"></el-input>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    import multiItemMixin from './multiItemMixin'

    export default {
        mixins: [multiItemMixin],
        data () {
            return {
                ruleForm: this.init,
                resetData: Object.assign({}, this.init),
                rules: {
                    name: [
                        {required: true, message: '请输入游戏名称', trigger: 'blur'}
                    ],
                    duration: [
                        {required: true, message: '请输入游戏时长', trigger: 'blur'}
                    ],
                    achievement: [
                        {required: true, message: '请输入游戏成就', trigger: 'blur'}
                    ]
                },
                isEdit: !(this.init.isEdit === false)
            }
        }
    }

</script>


// WEBPACK FOOTER //
// experience.vue?7c98bce4